import { PartnerUserPermissions } from "providers/Auth";
import { ApplicantStatus, ApplicationStatus } from "shared/types";
import { Applicant } from "types/application";

// Toggle disabled state
export const canDecisionBeMade = ({
  applicants,
  status,
  type,
  permissions,
  requirements
}: {
  applicants: Applicant[];
  status: ApplicationStatus;
  type: { isPropertyManager: boolean };
  permissions: PartnerUserPermissions;
  requirements?: string[];
}) => {
  if (type.isPropertyManager && !permissions.canMakeDecisions) return false;

  if (requirements?.length) return false;

  if (
    [
      ApplicationStatus.Approved,
      ApplicationStatus.Rejected,
      ApplicationStatus.ConditionalApproved,
      ApplicationStatus.Canceled,
      ApplicationStatus.Merged
    ].includes(status)
  )
    return false;

  return applicants.some(
    (applicant: Applicant) =>
      applicant.application_status === ApplicantStatus.Submitted
  );
};

// Toggles whether the button is visible at all
export const canSeeDecisionButton = ({
  permissions,
  type,
  status
}: {
  permissions: PartnerUserPermissions;
  type: { isPropertyManager: boolean };
  status: ApplicationStatus;
}) => {
  const isStatusBlocked = [
    ApplicationStatus.Approved,
    ApplicationStatus.Rejected,
    ApplicationStatus.ConditionalApproved,
    ApplicationStatus.OnHold
  ].includes(status);

  if (isStatusBlocked) return false;

  return !(type.isPropertyManager && !permissions.canMakeDecisions);
};
